import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';
import $ from 'jquery';


class ModuleReaSlider {

  constructor(){
    this.slider = jQuery(`[data-trigger='module-rea-slider']`);
    this.nav      = $('#js--module-layout-slider__nav');
    this.navItems = this.nav.find('li');
    this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] ){
        
        const carousel = this.slider.owlCarousel({
          items:              1,
          nav:                false,
          navText:            ['',''],
          dots:               false,
          navContainerClass:  'owl-nav-realisations',
          onTranslated      : this.updateNav.bind(this),
          autoplay:           false,
          autoHeight:         true,
          touchDrag: false,
          mouseDrag:false,
        });

        var i = 1;
        $('#js--Pageprecedante').on('click', function() {
          if(i==3){$('#js--Pagesuivante').fadeIn(200);}
          if(i!=1){i--;}
          carousel.trigger('prev.owl.carousel');;
          $('.nbPage span').html(i);
      });
        $('#js--Pagesuivante').on('click', function() {
            carousel.trigger('next.owl.carousel'); i++;
            $('.nbPage span').html(i);
            if(i==3){$(this).fadeOut(200);}
        });

      }  

    });
  }

	/*
	 * Change l'état actif de la navigation du carousel
	 * en fonction de l'index de la slide active
	 */
	updateNav(event){
		$(this.navItems).removeClass('js--active');
		$(this.navItems).eq(event.item.index).addClass('js--active');
	}

}

export const moduleReaSlider = new ModuleReaSlider();